import { styled } from '@mui/material/styles';
import React from 'react';
import PropTypes from 'prop-types';

import AppRoutes from './AppRoutes';
import { SeoProvider } from './components/Seo';
import { AppProvider } from './hooks/AppProvider';
import { CookieProvider } from './hooks/CookieProvider';

const AppContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  backgroundImage: theme.palette.background.gradient,
}));

const App = ({ url = null, onSeoChange = null }) => {
  return (
    <SeoProvider onSeoChange={onSeoChange}>
      <AppProvider>
        <CookieProvider>
          <AppContainer>
            <AppRoutes url={url} />
          </AppContainer>
        </CookieProvider>
      </AppProvider>
    </SeoProvider>
  );
}

App.propTypes = {
  url: PropTypes.string,
  onSeoChange: PropTypes.func,
};

export default App;
